import { StationeryTemplateCategoryEnum } from '@graphql/generated';
import { Skeleton } from '@shared/components/Skeleton';
import { Box, Flex } from '@withjoy/joykit';
import React from 'react';
import { useCardCategoryContext } from '../CardCategoryProvider';
import { Gallery } from '../Gallery';
import { GalleryTile } from '../GalleryTile';
import { PageSection } from '../PageSection';

export const DesignsGallerySkeleton = () => {
  const { currentCategory } = useCardCategoryContext();

  const isCategoryWithConciergeService = [StationeryTemplateCategoryEnum.invitation, StationeryTemplateCategoryEnum.saveTheDate].includes(currentCategory);

  return (
    <>
      <PageSection
        id="design-gallery-skeleton"
        paddingX={0}
        spacing={{ _: 7, md: 9 }}
        title={() =>
          isCategoryWithConciergeService ? (
            <Box>
              <Skeleton
                width={270}
                height={7}
                marginX={{ _: 6, md: 8 }}
              />
            </Box>
          ) : (
            <Flex
              justifyContent="center"
              flexDirection="column"
              alignItems="center"
              rowGap={5}
            >
              <Skeleton
                width={340}
                height={36}
              />
              <Skeleton
                width={400}
                height={18}
              />
              <Skeleton
                width={280}
                height={18}
              />
            </Flex>
          )
        }
      >
        <Gallery>
          {Array.from({ length: 8 }).map((_, index) => (
            <GalleryTile.Skeleton key={index} />
          ))}
        </Gallery>
      </PageSection>
    </>
  );
};
